import { defineStore } from 'pinia'
import { ref, computed, type Ref } from 'vue'
import type { FileDTO } from '../media/media'
import { useLocalStorage } from '@vueuse/core'
import {
  type PhotoEnhancePlanDTO,
  type BackgroundListCached,
  type PhotoEnhanceTaskDTO,
  type PhotoEnhanceNodeDTO,
  type PhotoMaterialDTO,
  type SelectedPhotoMaterialDTO,
  type PhotoLayoutResponse,
  type PhotoLayout
} from '@/composables/portrait/portrait'
export const usePortraitStore = defineStore('portrait', () => {
  // 性别选择 (1: 男, 2: 女) - 默认为男性 (1)
  const gender = ref<number>(1)

  // 用户选中的背景图片文件
  const selectedBackground = ref<PhotoEnhancePlanDTO | null>(null)

  const isCheckBaseInfo = ref<boolean>(false)
  const age = ref<number>(50)

  //保存美颜参数
  const isModified = ref<boolean>(false)
  const faceAge = ref<number>(0)
  const beautify = ref<number>(0)
  const clarity = ref<number>(0)

  const backgroundList = ref<PhotoEnhancePlanDTO[]>([])

  const uploadImageFile = ref<FileDTO | null>(null)
  const capability = ref<number>(0)

  //三种图片（均是服务端返回的）
  //原图 用户上传的 经过简单裁剪
  const originalImage = ref<string>('')
  //经过处理的正式遗照
  const portraitImage = ref<string>('')
  // 遗照水印版
  const watermarkImage = ref<string>('')

  const photoEnhanceTask = ref<PhotoEnhanceTaskDTO | null>(null)

  const sliderValue = ref<number>(25)

  const photoHairList = ref<PhotoMaterialDTO[]>([])
  const photoClothesList = ref<PhotoMaterialDTO[]>([])

  const photoHairRecommendList = ref<PhotoMaterialDTO[]>([])
  const photoClothesRecommendList = ref<PhotoMaterialDTO[]>([])

  const lastelectedPhotoMaterial = ref<SelectedPhotoMaterialDTO>({
    hair: null as PhotoMaterialDTO | null,
    cloth: null as PhotoMaterialDTO | null,
    beauty: [] as Array<string>
  })
  const selectedPhotoMaterial = ref<SelectedPhotoMaterialDTO>({
    hair: null as PhotoMaterialDTO | null,
    cloth: null as PhotoMaterialDTO | null,
    beauty: [] as Array<string>
  })

  const currentNodeId = ref<string>('')

  const cropImageList = ref<PhotoLayout[]>([])
  const croppedImage = ref<FileDTO | null>(null)

  const currentSize = ref<string>('')

  function setLastelectedPhotoMaterial() {
    lastelectedPhotoMaterial.value = selectedPhotoMaterial.value
  }
  /**
   * 历史记录保存
   * 需要维护一个历史记录的数组，数组包含
   * node
   */

  function setSelectedPhotoMaterial(material: PhotoMaterialDTO | string[] | null, category: string) {
    if (category === 'cloth') {
      selectedPhotoMaterial.value.cloth = material as PhotoMaterialDTO | null
    } else if (category === 'hair') {
      selectedPhotoMaterial.value.hair = material as PhotoMaterialDTO | null
    } else {
      selectedPhotoMaterial.value.beauty = material as Array<string>
    }
  }
  function setPhotoMaterialList(list: PhotoMaterialDTO[], category: string) {
    if (category === 'cloth') {
      photoClothesList.value = list.filter((item) => {
        if (gender.value === 1) {
          return item.gender === 'male'
        } else {
          return item.gender === 'female'
        }
      })
      photoClothesRecommendList.value = photoClothesList.value.filter((item) => {
        return item.endAge >= age.value && item.startAge <= age.value
      })
    } else {
      photoHairList.value = list.filter((item) => {
        if (gender.value === 1) {
          return item.gender === 'male'
        } else {
          return item.gender === 'female'
        }
      })
      photoHairRecommendList.value = photoHairList.value.filter((item) => {
        return item.endAge >= age.value && item.startAge <= age.value
      })
    }
    console.log('photoHairRecommendList.value:', photoHairRecommendList.value)
    console.log('photoClothesRecommendList.value:', photoClothesRecommendList.value)
    console.log('photoHairList.value:', photoHairList.value)
    console.log('photoClothesList.value:', photoClothesList.value)
  }

  function setCurrentPhotoNode(node: PhotoEnhanceNodeDTO) {
    console.log('!!!!! photoEnhanceTask.value', photoEnhanceTask.value)
    if (photoEnhanceTask.value) {
      photoEnhanceTask.value.nodes[photoEnhanceTask.value.nodes.length - 1] = node
      currentNodeId.value = node.id
      console.log('!!!!! node', node)
      console.log('!!!!! currentNodeId.value', currentNodeId.value)
    } else {
      return
    }
  }

  function setSliderValue(value: number) {
    sliderValue.value = value
  }

  function pushNewNode(node: PhotoEnhanceNodeDTO) {
    if (photoEnhanceTask.value) {
      photoEnhanceTask.value.nodes.push(node)
    }
  }

  function setPhotoEnhanceTask(task: PhotoEnhanceTaskDTO) {
    console.log('!!!!! setPhotoEnhanceTask', task)
    photoEnhanceTask.value = task
    console.log('!!!!! photoEnhanceTask.value', photoEnhanceTask.value)
  }
  function setUploadFile(file: FileDTO) {
    uploadImageFile.value = file
  }
  function setGender(val: number) {
    console.log('!!')
    gender.value = val
  }
  function setOriginalImage(imageUrl: string) {
    originalImage.value = imageUrl
  }
  function setPortraitImage(imageUrl: string) {
    portraitImage.value = imageUrl
  }
  function setWatermarkImage(imageUrl: string) {
    watermarkImage.value = imageUrl
  }

  function setBackground(bg: PhotoEnhancePlanDTO) {
    selectedBackground.value = bg
    console.log('Portrait Store: 已选择背景', bg.planName)
  }

  function setIsCheckBaseInfo() {
    isCheckBaseInfo.value = true
  }

  function setFaceAge(age: number) {
    faceAge.value = age
  }

  function setBeautify(val: number) {
    beautify.value = val
  }

  function setClarity(val: number) {
    clarity.value = val
  }
  function setIsModified(val: boolean) {
    isModified.value = val
  }

  function setBackgroundList(list: PhotoEnhancePlanDTO[]) {
    backgroundList.value = list
  }

  /**
   * 重置整个遗像模块的状态
   * 在用户退出流程或组件卸载时使用
   */
  function resetStore() {
    gender.value = 1
    age.value = 50
    sliderValue.value = 25
    photoHairList.value = []
    photoClothesList.value = []
    photoHairRecommendList.value = []
    photoClothesRecommendList.value = []
    selectedPhotoMaterial.value = {
      hair: null as PhotoMaterialDTO | null,
      cloth: null as PhotoMaterialDTO | null,
      beauty: [] as Array<string>
    }
    currentNodeId.value = ''
    lastelectedPhotoMaterial.value = {
      hair: null as PhotoMaterialDTO | null,
      cloth: null as PhotoMaterialDTO | null,
      beauty: [] as Array<string>
    }
    selectedBackground.value = null
    isCheckBaseInfo.value = false
    faceAge.value = 0
    beautify.value = 0
    clarity.value = 0
    uploadImageFile.value = null
    originalImage.value = ''
    portraitImage.value = ''
    watermarkImage.value = ''
    photoEnhanceTask.value = null
    cropImageList.value = []
    croppedImage.value = null
  }

  // 返回所有需要暴露的状态、计算属性和方法
  return {
    gender,
    selectedBackground,
    isCheckBaseInfo,
    age,
    faceAge,
    beautify,
    clarity,
    capability,
    originalImage,
    portraitImage,
    watermarkImage,
    isModified,
    uploadImageFile,
    photoEnhanceTask,
    sliderValue,
    photoHairList,
    photoClothesList,
    photoHairRecommendList,
    photoClothesRecommendList,
    selectedPhotoMaterial,
    currentNodeId,
    backgroundList,
    cropImageList,
    croppedImage,
    currentSize,
    setLastelectedPhotoMaterial,
    pushNewNode,
    setSelectedPhotoMaterial,
    setSliderValue,
    setCurrentPhotoNode,
    setPhotoEnhanceTask,
    setUploadFile,
    setOriginalImage,
    setPortraitImage,
    setWatermarkImage,
    setGender,
    setBackground,
    setIsCheckBaseInfo,
    setFaceAge,
    setBeautify,
    setClarity,
    setBackgroundList,
    setIsModified,
    resetStore,
    setPhotoMaterialList
  }
})
